import React from "react";
const staffprofile = () => {
  return <div>staff Profile</div>;
};

export default staffprofile;
